module.exports = __webpack_public_path__ + "static/media/HAPPYHAIR_b.8760ca41.png";